import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { browserHistory } from 'react-router';
import './Dashboard.scss';
import PlanUtilities from '../../../services/PlanService';
import changeSpeed from './change-speed.svg';
import DashboardConstants from '../DashboardConstants';

const getFibreChange = (customerInfo, plans, hasError) => (
  <div className="account-action-tile">
    {(PlanUtilities.canUpgrade(customerInfo, plans) && !hasError) &&
    <div className="upgrade-message">
      Looks like you can get faster speeds at your address.
    </div>
    }
    <img
      src={changeSpeed}
      alt="Change Speed"
    />
    <div className="account-action-tile-title">
      Want to change your speed?
    </div>
    <div className="account-action-tile-text">
      If you&apos;d like to change the speed of your Skinny Unlimited Broadband, do it here.
      Plan changes are free.
    </div>
    <Button id="change-speed-button" onClick={() => browserHistory.push('/change')}>
      {DashboardConstants.CHANGE_SPEED}
    </Button>
  </div>
);

const getDslNoChange = () => (
  <div className="account-action-tile">
    <img
      src={changeSpeed}
      alt="Change Speed"
    />
    <div className="account-action-tile-title">
      Speed upgrade
    </div>
    <div className="account-action-tile-text">
      Looks like speed upgrade isn&apos;t available at your address.
      Remember to check back to see if Skinny Fibre becomes available.
    </div>
    <Button id="change-speed-button" onClick={null} disabled>
      {DashboardConstants.CHANGE_SPEED}
    </Button>
  </div>
);

const getFibreUpgrade = (customerInfo, plans, hasError) => (
  <div id="change-speed-tile" className="account-action-tile">
    {(PlanUtilities.canUpgrade(customerInfo, plans) && !hasError) &&
    <div className="upgrade-message">
      Awesome, it looks like you can get Fibre at your address now!
    </div>
    }
    <img
      src={changeSpeed}
      alt="Change Speed"
    />
    <div className="account-action-tile-title">
      Get faster with fibre!
    </div>
    <div className="account-action-tile-text">
      Click on the &quot;Upgrade to Fibre&quot; button,
      and we&apos;ll get you started on your journey to ultra-fast broadband.
    </div>
    <Button id="change-speed-button" onClick={() => browserHistory.push('/change')}>
      UPGRADE TO FIBRE
    </Button>
  </div>
);

const ChangeSpeedTile = (props) => {
  const { customerInfo, plans, hasError } = props;
  if (customerInfo.requestInProgress) {
    return null;
  }
  if (PlanUtilities.hasFibre(customerInfo)) {
    return getFibreChange(customerInfo, plans, hasError);
  }
  if (PlanUtilities.hasDslOnly(plans)) {
    return getDslNoChange();
  }
  if (PlanUtilities.canUpgradeToFibre(customerInfo, plans)) {
    return getFibreUpgrade(customerInfo, plans, hasError);
  }
  return null;
};

ChangeSpeedTile.propTypes = {
  customerInfo: PropTypes.object.isRequired,
  plans: PropTypes.object.isRequired,
  hasError: PropTypes.bool
};

export default ChangeSpeedTile;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/Dashboard/ChangeSpeedTile.js
 **/